import { Component, EventEmitter, OnInit, Output, Input, OnDestroy } from '@angular/core';
import { formatDate } from '@angular/common';
import { ReportService } from '../services/report.service';
import { ReportFilters } from '../models/report-filters.model';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'report-export-button',
    templateUrl: 'report-export.component.html'
})

export class ReportExportComponent implements OnInit, OnDestroy {
    @Output() exportClick: EventEmitter<any> = new EventEmitter();
    isButtonReadOnly : boolean;
    @Input() exportUrl : string;
    @Input() reportFilters: ReportFilters;
    @Input() fileName:string;
    @Input() filtersUpdated: Observable<void>;
    private filterEventSubscription: Subscription;
    errorMessage: string = '';
    reportLoading: boolean = false;
    ngOnInit() {
        if(this.filtersUpdated){
            this.filterEventSubscription = this.filtersUpdated.subscribe(() =>{

             this.errorMessage = '';});
       }
    }
    constructor(private reportService: ReportService){
        
    }
    ngOnDestroy(): void {
        if(this.filtersUpdated){
             this.filterEventSubscription.unsubscribe();
        }
    }
    exportButtonClick() {
        this.isButtonReadOnly = true;
        this.errorMessage ='';
        if(this.reportFilters.periodEndDates && this.reportFilters.periodEndDates.length > 13){
            this.isButtonReadOnly = false;
            this.errorMessage ='You have exceeded the 13 export pay period limit.  Please select 13 pay periods or less and try again.';
        }
        else{
            this.reportLoading = true;
            this.reportService.getExportData(this.reportFilters,this.exportUrl)
                .then(data=>{
                    if(data){
                       this.exportToCSV(data,this.fileName);                   
                    }
                    else{
                        this.errorMessage = 'An error has occurred and cannot return an export.  Please limit the pay periods selected, and try again.';
                    }
                    this.isButtonReadOnly = false;
                    this.reportLoading = false;
                })
                .catch(error=>{
                    this.errorMessage = 'An error has occurred and cannot return an export.  Please limit the pay periods selected, and try again.';
                    this.isButtonReadOnly = false;
                    this.reportLoading = false;
                });              
        }
  }   

  private exportToCSV(data, filename = 'data') {
         let csvData = this.ConvertToCSV(data);
       let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
     this.DownloadCSV(blob,filename)
   }

   private DownloadCSV(blob,filename)
   {
       let tempDownloadLink = document.createElement("a");
       let tempUrl = URL.createObjectURL(blob);
       let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
       if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
           tempDownloadLink.setAttribute("target", "_blank");
       }
       tempDownloadLink.setAttribute("href", tempUrl);
       let currentDateTime = formatDate(new Date(), 'MMddyyyyHHmmss', 'en-US');
       tempDownloadLink.setAttribute("download", filename +"_"+currentDateTime+ ".csv");
       tempDownloadLink.style.visibility = "hidden";
       document.body.appendChild(tempDownloadLink);
       tempDownloadLink.click();
       document.body.removeChild(tempDownloadLink);
   }


   ConvertToCSV(jsonData) {
       let str = '';
       let headers = jsonData.headers
       str += headers + '\r\n';
       for (let rowData of jsonData.rowList) {
           str += rowData + '\r\n';
       }
       return str;
   }
}
